import React, { lazy, Suspense } from "react";
import { Outlet, BrowserRouter, Route, Routes, Navigate, Link } from "react-router-dom";

import ErrorBoundary from "./ErrorBoundary";
import { PUBLIC_ROUTE } from "./route.constants";
import { LoadingStubber, Loader } from "@components/loader";
import { Redirect } from "@components/fairGoRedirect/fairGoRedirect";
import { NotFound } from "@containers/404/404";
import { routeConfig } from "./routeConfig";

export function AppRoutes() {
  return (
    <ErrorBoundary>
      <Suspense fallback={<Loader />}>
        <Routes>
          <Route key={`route-${PUBLIC_ROUTE.INDEX}`} path={PUBLIC_ROUTE.INDEX} element={<Redirect pathname={PUBLIC_ROUTE.LANDING} withSearch />}/>
          {routeConfig.map(route => <Route key={`route-${route.path}`} path={route.path} element={<LoadingStubber>{route.element}</LoadingStubber>} />)}
          <Route key={`route-NOT_FOUND`} path="*" element={<NotFound />} />
        </Routes>
      </Suspense>
    </ErrorBoundary>
  );
}